export default function Index() {
  return (
    <main className="page-main pkt-container pkt-txt-center">
      <h1>React komponenter</h1>
      <p>
        <img
          className="pkt-logo"
          alt="Punkt logo"
          aria-hidden="true"
          src="https://cdn-nocors.punkt.oslo.systems/latest/icons/punkt-circle-blue.svg"
        />

        <img
          className="pkt-logo"
          alt="Punkt logo"
          aria-hidden="true"
          src="https://cdn-nocors.punkt.oslo.systems/latest/icons/react.svg"
        />
      </p>
    </main>
  )
}
